import React, {useState} from 'react'

import _ from 'lodash/fp'
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {getSelectedMoot} from "../../reducers/mootSelectors";
import { saveMoot } from '../../actions/mootActions'
import {Button, Chip, CircularProgress, Snackbar, TextField as MUITextField, Typography} from "@material-ui/core";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextInput from "../common/TextInput";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {
    DatePicker,
    DesktopDateTimePicker,
    LocalizationProvider,
    TimePicker
} from "@mui/x-date-pickers";
import {add, addDays, format, parseISO} from "date-fns";
import './Moot.css'
import {isNotEmpty, mapWithIndex} from "../../utils/funcUtils";
import {Link, useHistory} from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import {Create, Check, Cancel} from "@material-ui/icons";
import {Edit, Start} from "@mui/icons-material";
import {Alert} from "@mui/material";
import {
    asHongKongDate,
    asHongKongDateString,
    formatInTimeZone,
    hongKongTimeFromUTC,
    utcFromHongKongTime
} from "../../utils/dateUtils";
import {utcToZonedTime} from "date-fns-tz";
import ClarificationCategoryItem from './ClarificationCategoryItem'

const Moot = ({selectedMootId, selectedMoot, getSelectedMoot = _.noop, saveMoot, saveMootError}) => {

    const ROUND_TYPES = {
        GENERAL_ROUNDS: 'General Rounds',
        ROUND_OF_32: 'Elimination Rounds: Round of 32',
        ROUND_OF_16: 'Elimination Rounds: Round of 16',
        QUARTERFINALS: 'Elimination Rounds: Quarter-Finals',
        SEMIFINALS: 'Elimination Rounds: Semi-Finals',
        FINALS: 'Finals',
        CHAMPION: 'Champion'
    }

    const history = useHistory()

    const [busy, setBusy] = React.useState(false)
    const [saving, setSaving] = React.useState(false)
    const [saved, setSaved] = React.useState(false)
    const [newMoot, setNewMoot] = useState({
        mootLocation: 'Hong Kong',
        mootLocalTimezone: 'Asia/Hong_Kong'
    })
    const [scheduleStartDate, setScheduleStartDate] = useState()
    const [selectedScheduleStartDate, setSelectedScheduleStartDate] = useState(null)
    const [schedule, setSchedule] = useState([])
    const [newTimes, setNewTimes] = useState({})
    const [toggleAdd, setToggleAdd] = useState()
    const [validationError, setValidationError] = useState('')
    const [clarificationCategories, setClarificationCategories] = useState([])
    const [newCategoryName, setNewCategoryName] = useState('')

    const formatScheduleDate = date => {
        return format(date, 'dd MMMM, EEEE')
    }

    // Helper function to handle date changes with 59 seconds
    const handleDateChangeWith59Seconds = (dateValue, fieldName) => {
        if (dateValue) {
            // Ensure we have a valid Date object and clone it to avoid mutations
            const date = new Date(dateValue);
            if (isNaN(date.getTime())) {
                console.error('Invalid date received:', dateValue);
                return;
            }
            // Set seconds to 59 and milliseconds to 0 for precise formatting
            date.setSeconds(59, 0);
            
            // Convert to UTC using the utility function
            const utcDate = utcFromHongKongTime(date);
            
            setNewMoot({
                ...newMoot,
                [fieldName]: utcDate
            });
        } else {
            setNewMoot({
                ...newMoot,
                [fieldName]: null
            });
        }
    }


    const buildScheduleFromMootRounds = moot => {
        //Given the existing mootRounds build the schedule structure
        const newSchedule = _.pipe(
            _.map(round => ({
                date: { display: formatInTimeZone(parseISO(round.date),'dd MMMM, EEEE',"Asia/Hong_Kong"), value: round.date},
                roundType: round.roundType
            })),
            _.groupBy(item => `${item.date.display}-${item.roundType}`),
            _.map(times => {
                const roundTimes = _.map(t => (
                    {display: formatInTimeZone(parseISO(t.date.value),'hh:mm aa',"Asia/Hong_Kong"), value: t.date.value}
                ), times)

                // Sort times by their value to ensure chronological order
                const sortedRoundTimes = _.sortBy(t => t.value, roundTimes)

                return {
                    date: _.head(times)?.date,
                    times: sortedRoundTimes,
                    roundType: ROUND_TYPES[_.head(times)?.roundType]
                }
            })
        )(moot?.MootRound)        
        const sortedNewSchedule = _.sortBy(item => item.date.value,newSchedule)
        setSchedule(sortedNewSchedule)
    }
    const buildGeneralRoundTimeObjects = startDate => {
        let result = []

        const firstTime = add(startDate, {hours: 8, minutes: 30})
        const secondTime = add(startDate, {hours: 10, minutes: 30})
        const thirdTime = add(startDate, {hours: 12, minutes: 30})
        const fourthTime = add(startDate, {hours: 14, minutes: 30})
        const fifthTime = add(startDate, {hours: 16, minutes: 30})

        result.push({
            display: format(firstTime, 'hh:mm aa'),
            value: utcFromHongKongTime(firstTime)
        })
        result.push({
            display: format(secondTime, 'hh:mm aa'),
            value: utcFromHongKongTime(secondTime)
        })
        result.push({
            display: format(thirdTime, 'hh:mm aa'),
            value: utcFromHongKongTime(thirdTime)
        })
        result.push({
            display: format(fourthTime, 'hh:mm aa'),
            value: utcFromHongKongTime(fourthTime)
        })
        result.push({
            display: format(fifthTime, 'hh:mm aa'),
            value: utcFromHongKongTime(fifthTime)
        })

        return result
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSaved(false);
    };

    const buildSchedule = (startDate) => {

        if (!startDate)
            return []

        const scheduleStartDate = new Date(startDate);
        scheduleStartDate.setHours(0, 0, 0, 0);

        const newSchedule = []
        // The general rounds schedule is set to be startDate + the next 3 days
        // The time intervals is 8:30 10:30 12:30 2:30 4:30
        buildGeneralRoundTimeObjects(scheduleStartDate)

        newSchedule.push({
            date: { display: formatScheduleDate(scheduleStartDate), value: utcFromHongKongTime(scheduleStartDate)},
            times: buildGeneralRoundTimeObjects(scheduleStartDate),
            roundType: ROUND_TYPES.GENERAL_ROUNDS
        })
        newSchedule.push({
            date:  { display: formatScheduleDate(addDays(scheduleStartDate, 1)), value: utcFromHongKongTime(addDays(scheduleStartDate, 1))},
            times: buildGeneralRoundTimeObjects(addDays(scheduleStartDate, 1)),
            roundType: ROUND_TYPES.GENERAL_ROUNDS
        })
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 2)), value: utcFromHongKongTime(addDays(scheduleStartDate, 2))},
            times: buildGeneralRoundTimeObjects(addDays(scheduleStartDate, 2)),
            roundType: ROUND_TYPES.GENERAL_ROUNDS
        })
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 3)), value: utcFromHongKongTime(addDays(scheduleStartDate, 3))},
            times: buildGeneralRoundTimeObjects(addDays(scheduleStartDate, 3)),
            roundType: ROUND_TYPES.GENERAL_ROUNDS
        })
        //Elimination Round of 32 is startDate + 4
        // Time intervals is 9:00 11:00
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 4)), value: utcFromHongKongTime(addDays(scheduleStartDate, 4))},
            times: [
                {
                display: format(add(addDays(scheduleStartDate, 4), {hours: 9}), 'hh:mm aa'),
                value: utcFromHongKongTime(add(addDays(scheduleStartDate, 4), {hours: 9}))
                },
                {
                    display: format(add(addDays(scheduleStartDate, 4), {hours: 11}), 'hh:mm aa'),
                    value: utcFromHongKongTime(add(addDays(scheduleStartDate, 4), {hours: 11}))
                }
            ], roundType: ROUND_TYPES.ROUND_OF_32
        })

        //Elimination Round of 16 is startDate +4
        // Time interval is 3:00
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 4)), value: utcFromHongKongTime(addDays(scheduleStartDate, 4))},
            times: [
                {
                    display: format(add(addDays(scheduleStartDate, 4), {hours: 15}), 'hh:mm aa'),
                    value: utcFromHongKongTime(add(addDays(scheduleStartDate, 4), {hours: 15}))
                }
            ],
            roundType: ROUND_TYPES.ROUND_OF_16
        })

        //Elimination Round Quarter finals is startDate + 5
        // Time is 9:00
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 5)), value: utcFromHongKongTime(addDays(scheduleStartDate,5))},
            times: [
                {
                    display: format(add(addDays(scheduleStartDate, 5), {hours: 9}), 'hh:mm aa'),
                    value: utcFromHongKongTime(add(addDays(scheduleStartDate, 5), {hours: 9}))
                },

            ],
            roundType: ROUND_TYPES.QUARTERFINALS
        })

        //Elimination Round Semi finals is startDate + 5
        // Time is 1:00
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 5)),value: utcFromHongKongTime(addDays(scheduleStartDate,5))},
            times: [
                {
                    display: format(add(addDays(scheduleStartDate, 5), {hours: 13}), 'hh:mm aa'),
                    value: utcFromHongKongTime(add(addDays(scheduleStartDate, 5), {hours: 13}))
                }
            ],
            roundType: ROUND_TYPES.SEMIFINALS
        })

        //Finals is startDate + 6
        // Time is 1:00
        newSchedule.push({
            date: { display: formatScheduleDate(addDays(scheduleStartDate, 6)), value: utcFromHongKongTime(addDays(scheduleStartDate,6))},
            times: [
                {
                    display: format(add(addDays(scheduleStartDate, 6), {hours: 13}), 'hh:mm aa'),
                    value: utcFromHongKongTime(add(addDays(scheduleStartDate, 6), {hours: 13}))
                }
            ],
            roundType: ROUND_TYPES.FINALS
        })

        // Sort the schedule by date in ascending order
        const sortedNewSchedule = _.sortBy(item => item.date.value, newSchedule)
        setSchedule(sortedNewSchedule)
    }


    const handleRemoveScheduleTime = (date, time) => {
        // Find the schedule entry that contains this time
        const scheduleEntry = _.find(s => s.date === date, schedule);
        
        if (!scheduleEntry) return;

        // Remove the time and update the schedule
        const newSchedule = _.map(s => {
            if (s.date === date) {
                const times = _.filter(t => t !== time, s.times)
                const sortedTimes = _.sortBy(t => t.value, times)
                return {
                    ...s,
                    times: sortedTimes
                }
            } else
                return s
        }, schedule)

        // Sort the schedule by date in ascending order to maintain proper order
        const sortedNewSchedule = _.sortBy(item => item.date.value, newSchedule)
        setSchedule(sortedNewSchedule)
        // Clear validation error when schedule changes
        setValidationError('')
    }

    const addScheduleTime = (date, time, roundType) => {       
        // Ensure time is a valid Date object
        let validTime = time;
        if (typeof time === 'string') {
            validTime = new Date(time);
        }
        
        // If it's still not valid, try to parse it
        if (!validTime || isNaN(validTime)) {
            console.error('Invalid time provided to addScheduleTime:', time);
            return;
        }
        
        // Find the original schedule entry to get the correct date
        // For General Rounds and other round types that may span multiple dates,
        // we need to match by EXACT date.display AND roundType
        let scheduleEntry = null;
        for (let s of schedule) {
            if (s.date.display === date && s.roundType === roundType) {
                scheduleEntry = s;
                break;
            }
        }
        
        if (!scheduleEntry) {
            scheduleEntry = _.find(s => s.date.display === date && s.roundType === roundType, schedule);
        }
        
        if (!scheduleEntry) {
            console.error('Could not find schedule entry for date and round type');
            return;
        }
        
        // Verify we found the right entry
        if (scheduleEntry.date.display !== date) {
            console.error('Found wrong schedule entry! Expected:', date, 'Got:', scheduleEntry.date.display);
            return;
        }
        
        // Create a new date object using the original schedule date but with the selected time
        // Extract the date part from the original schedule entry and combine with selected time
        const originalDateString = scheduleEntry.date.value; // e.g., '2026-03-19T00:30:00.000Z'
        const datePart = originalDateString.split('T')[0]; // e.g., '2026-03-19'
        
        // Create a fresh date object using the correct date and selected time
        const selectedHours = validTime.getHours().toString().padStart(2, '0');
        const selectedMinutes = validTime.getMinutes().toString().padStart(2, '0');
        const newDateTimeString = `${datePart}T${selectedHours}:${selectedMinutes}:00.000`;
        
        // Create the date object in the local timezone context
        const timeWithCorrectDate = new Date(newDateTimeString);
        
        const newSchedule = _.map(s => {
            if (s.date.display === date && s.roundType === roundType) {
                const newTimes = [...s.times, {display: format(timeWithCorrectDate, 'hh:mm aa'), value: utcFromHongKongTime(timeWithCorrectDate).toISOString()}]
                const sortedTimes = _.sortBy(t => t.value,newTimes)
                return {
                    ...s,
                    times: sortedTimes
                }
            } else
                return s
        }, schedule)

        // Sort the schedule by date in ascending order to maintain proper order
        const sortedNewSchedule = _.sortBy(item => item.date.value, newSchedule)
        setSchedule(sortedNewSchedule)
        // Clear validation error when schedule changes
        setValidationError('')
    }


    React.useEffect(() => {
        const asyncFetchData = async () => {
            try {
                setBusy(true)
                if (selectedMootId) {
                    const moot = await getSelectedMoot(selectedMootId)
                    buildScheduleFromMootRounds(moot)
                    setNewMoot(moot)
                    const categories = moot?.ClarificationCategories?.map(cat => cat.name) || []
                    setClarificationCategories(categories)
                }
                setBusy(false)
            } catch (e) {
                //TODO ?
                setBusy(false)
            }
        }
        asyncFetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const canNoLongerAdd = (roundType,date) => {
        const found = _.find(s => s.date === date, schedule)
        
        if (!found) {
            return false
        }
        
        const currentTimeCount = _.size(found.times)
        
        switch (roundType) {
            case ROUND_TYPES.ROUND_OF_32:
                return currentTimeCount >= 16
            case ROUND_TYPES.ROUND_OF_16:
                return currentTimeCount >= 8
            case ROUND_TYPES.QUARTERFINALS:
                return currentTimeCount >= 4
            case ROUND_TYPES.SEMIFINALS:
                return currentTimeCount >= 2
            case ROUND_TYPES.FINALS:
                return currentTimeCount >= 1
            default:
                return false
        }
    }

    const validateSchedule = () => {
        // Check if any round type has no time slots
        const roundTypesWithTimes = _.pipe(
            _.groupBy('roundType'),
            _.mapValues(entries => _.reduce((acc, entry) => acc + entry.times.length, 0, entries))
        )(schedule)

        const roundTypesWithoutTimes = _.filter(count => count === 0, roundTypesWithTimes)
        
        if (_.size(roundTypesWithoutTimes) > 0) {
            return "All rounds for oral arguments require at least one time slot"
        }
        
        // For General Rounds specifically, check that each date has at least one time slot
        const generalRoundEntries = _.filter(s => s.roundType === ROUND_TYPES.GENERAL_ROUNDS, schedule)
        const generalRoundDatesWithoutTimes = _.filter(entry => entry.times.length === 0, generalRoundEntries)
        
        if (_.size(generalRoundDatesWithoutTimes) > 0) {
            return "All General Round dates require at least one time slot"
        }
        
        return ""
    }

    const addClarificationCategory = () => {
        if (newCategoryName.trim() && !clarificationCategories.includes(newCategoryName.trim())) {
            setClarificationCategories([...clarificationCategories, newCategoryName.trim()])
            setNewCategoryName('')
        }
    }

    const removeClarificationCategory = (categoryToRemove) => {
        setClarificationCategories(clarificationCategories.filter(cat => cat !== categoryToRemove))
    }

    const editClarificationCategory = (oldCategory, newCategory) => {
        if (newCategory.trim() && !clarificationCategories.includes(newCategory.trim())) {
            setClarificationCategories(
                clarificationCategories.map(cat => cat === oldCategory ? newCategory.trim() : cat)
            )
        }
    }

    const save = async e => {
        e.preventDefault()
        
        // Clear any previous validation errors
        setValidationError('')
        
        // Validate schedule before saving
        const scheduleValidationError = validateSchedule()
        if (scheduleValidationError) {
            setValidationError(scheduleValidationError)
            return
        }
        
        try {
            if (!saving) {
                setSaving(true)
                const result = await saveMoot(newMoot, schedule, clarificationCategories)
                if (isNotEmpty(result)) {
                    setSaved(true)
                }
                setSaving(false)
            }
        }catch(e){
            setSaving(false)
        }
    }
    return (
        <Container style={{paddingBottom: '10rem'}}>
            {busy &&
                <CircularProgress/>
            }
            {!busy &&
                <>
                <Button style={{ margin: '0 0 0 0' }} variant='text' component={Link} onClick={() => history.push('/admin/settings')} >
                    <ArrowBackIosIcon /> Back to Settings
                </Button>
                <Grid container style={{flexGrow: 1, padding: '20px'}} spacing={2}>
                    <Grid item xs={12}>
                        <Typography component='h1' variant='h4'>Moot Settings</Typography>
                    </Grid>
                </Grid>

                <form onSubmit={save}>                    
                    <Grid container item style={{background: "#F0F0F0", padding: "1.75rem", border: "1px solid #D8D8D8"}}>
                        <Grid item xs={12}>
                            <Typography component='h2' variant='h5' style={{marginBottom: '1rem'}}>General Settings</Typography>
                        </Grid>
                        <Grid container item spacing={4} xs={12} justifyContent="flex-start">                       
                            <Grid item xs={12} sm="auto">
                                <div style={{minWidth:"270px"}}>
                                <TextInput
                                    label='Moot Number'
                                    onChange={e => setNewMoot({
                                        ...newMoot,
                                        mootNumber: e.target.value
                                    })}
                                    value={newMoot.mootNumber}                                    
                                />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <div style={{minWidth:"270px"}}>
                                    <TextInput
                                        label='Open Override Code'
                                        value={newMoot.openOverrideCode}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            openOverrideCode: e.target.value
                                        })                                        
                                        }
                                        />
                                </div>
                            </Grid>                           
                            
                        </Grid>
                        {/* We have these fields in the DB but don't currently do anything with them so leaving this
                        code here if we revisit letting you modify these values*/}
                        {/*<Grid item xs={4} md={4}>*/}
                        {/*    <TextInput*/}
                        {/*        label='Moot Location'*/}
                        {/*        onChange={e => setNewMoot({*/}
                        {/*            ...newMoot,*/}
                        {/*            mootLocation: e.target.value*/}
                        {/*        })}*/}
                        {/*        value={newMoot.mootLocation || 'Hong Kong'}*/}
                        {/*    />*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={4} md={4}>*/}
                        {/*    <Autocomplete*/}
                        {/*        onChange={(event, newValue) => setNewMoot({*/}
                        {/*            ...newMoot,*/}
                        {/*            mootLocalTimezone: newValue*/}
                        {/*        })}*/}
                        {/*        value={newMoot.mootLocalTimezone || 'Asia/Hong_Kong'}*/}
                        {/*        options={Intl.supportedValuesOf('timeZone')}*/}
                        {/*        autoSelect*/}
                        {/*        renderInput={(params) => <MUITextField {...params} variant="standard" label="Moot Local Timezone" required />}*/}
                        {/*    />*/}
                        {/*</Grid>*/}
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDateTimePicker
                                            label="Moot Open Date (HKT)"
                                            inputFormat="MM/dd/yyyy hh:mm aa"
                                            value={hongKongTimeFromUTC(newMoot.mootStartDate) || null}
                                            renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                            onChange={e => setNewMoot({
                                                ...newMoot,
                                                mootStartDate: utcFromHongKongTime(e)
                                            })
                                            }
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm="auto">
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDateTimePicker
                                            label="Moot Close Date (HKT)"
                                            inputFormat="MM/dd/yyyy hh:mm aa"
                                            value={hongKongTimeFromUTC(newMoot.mootEndDate) || null}
                                            renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                            onChange={e => setNewMoot({
                                                ...newMoot,
                                                mootEndDate: utcFromHongKongTime(e)
                                            })
                                            }
                                        />
                                    </LocalizationProvider>
                                </Grid>
                        </Grid>

                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Visa Invitation Letter Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.visaLetterOpenDate) || null}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            visaLetterOpenDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Visa Invitation Letter Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.visaLetterCloseDate) || null}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            visaLetterCloseDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        
                        <Grid item xs={12} style={{marginTop:"4rem"}}>
                            <Typography component='h2' variant='h5' style={{marginBottom: '1rem'}}>Oral Arguments Schedule</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='body2'>ALL TIMES reflect Hong Kong Time (GMT+8). The ability to edit
                                this section will be disabled when the arbitrator registration open date
                                occurs.</Typography>
                        </Grid>
                        { _.isEmpty(schedule) &&
                        <Grid item xs={8} md={8} style={{margin: '1rem 0 1rem'}}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="General Round Start Date"
                                    inputFormat="MM/dd/yyyy"
                                    value={selectedScheduleStartDate || null}
                                    renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params}  inputProps={{
                                        ...params.inputProps,
                                        readOnly: true}} />}
                                    onChange={(date) => {     
                                        if (date) {
                                            setSelectedScheduleStartDate(date);                                            
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                            <Button color="primary"
                                        style={{ margin: '.5rem 0 .5rem 1rem'}}
                                        size="medium"
                                        variant='outlined'
                                        endIcon={<Start />}
                                        aria-haspopup="menu"
                                        onClick={(e) => {
                                            buildSchedule(selectedScheduleStartDate)
                                        }}
                                        disabled={selectedScheduleStartDate === null}
                                >Build Schedule</Button>
                        </Grid>
                        }
                        { isNotEmpty(schedule) &&                                                                                
                            <Grid item xs={12} style={{margin: '0.875rem 0 1rem'}}>                           
                                <Typography variant='body1' style={{display:"inline", marginRight:"1rem"}}>General Round Start Date: <strong>{schedule[0].date.display} {(new Date(schedule[0].date.value)).getFullYear()}</strong></Typography>
                                <Button color="primary"
                                        style={{ margin: '.5rem 0'}}
                                        size="medium"
                                        variant='outlined'
                                        startIcon={<PlaylistRemoveIcon />}
                                        aria-haspopup="menu"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            setSchedule([])
                                        }}
                                >Clear schedule and start over</Button>                                
                            </Grid>                            
                        }

                        {mapWithIndex((s, i) => {                            
                                return (<Grid key={`${s.date.value}-${s.roundType}`} container item xs={12} md={12}>
                                    {i === 0 &&
                                        <Grid item xs={12}><Typography style={{marginTop: '1rem'}} component='h3' variant='h6'>{s.roundType}</Typography></Grid>
                                    }
                                    {i > 0 && s.roundType !== schedule[i - 1]?.roundType &&
                                        <Grid item xs={12}><Typography style={{margin: '2rem 0 0 0'}} component='h3' variant='h6'>{s.roundType}</Typography></Grid>
                                    }
                                    <Grid item xs={12} style={{padding:'0.5rem 0'}}>                                     
                                    <span className='schedule-date' style={{display:'inline-block', minWidth:'195px'}}>{s.date.display}</span>
                                    {
                                        <>
                                            { mapWithIndex((t, idx) => (
                                                <Chip className='schedule-time' style={{marginLeft: "0.5rem"}}
                                                      key={`${s.date.value}-${t.value}`} label={t.display}
                                                      onDelete={() => handleRemoveScheduleTime(s.date, t)}/>
                                            )
                                            , s.times)
                                            }
                                            { toggleAdd !== `${s.date.display}-${s.roundType}` &&
                                            <Button onClick={() => {setToggleAdd(`${s.date.display}-${s.roundType}`)}}>+ Add a time</Button>
                                            }
                                            { toggleAdd === `${s.date.display}-${s.roundType}` &&
                                            <span className='schedule-time--add'>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <TimePicker                                                        
                                                        minutesStep={5}
                                                        value={newTimes[`${s.date.display}-${s.roundType}`] ?? null}
                                                        onChange={e => {
                                                            const key = `${s.date.display}-${s.roundType}`;
                                                            setNewTimes(prevNewTimes => ({...prevNewTimes, [key]: e}));
                                                        }}
                                                        renderInput={(params) => <MUITextField {...params} className='schedule-time--field'/>}/>
                                                </LocalizationProvider>
                                                <span>                                        
                                                <Button
                                                    style={{minWidth: '24px'}}
                                                    disabled={canNoLongerAdd(s.roundType,s.date)}
                                                    onClick={() => {
                                                        const key = `${s.date.display}-${s.roundType}`
                                                        const timeToAdd = newTimes[key]
                                                        if (timeToAdd) {
                                                            addScheduleTime(s.date.display, timeToAdd, s.roundType)
                                                            setNewTimes({})
                                                            setToggleAdd(null)
                                                        }
                                                    }}
                                                    
                                                    ><Check style={{color: '#05971a'}}/></Button>
                                                <Button                                                
                                                    onClick={() => {
                                                        setToggleAdd(null)
                                                        setNewTimes({})
                                                    }}                                                    
                                                    style={{minWidth: '24px'}}><Cancel style={{color: '#00000042'}}/></Button>
                                                </span>   
                                        </span>
                                        
                                            }

                                        </>
                                    }
                                    </Grid>                                 
                                </Grid>)
                            }
                            , schedule)
                            
                        }

                        <Grid item xs={12} style={{marginTop: '4rem'}}>                            
                            <Typography component='h2' variant='h5' style={{marginBottom: '1rem'}}>Team Settings</Typography>
                        </Grid>
                        <Grid container item spacing={4} xs={12} justifyContent="flex-start">
                            <Grid item xs={12} sm="auto">
                                <div style={{minWidth:"270px"}}>
                                <TextInput
                                    label='In Person Registration Fee (HK$)'
                                    value={newMoot.inPersonRegistrationFee}                                    
                                    onChange={e => setNewMoot({
                                        ...newMoot,
                                        inPersonRegistrationFee: e.target.value
                                    })
                                    }/>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <div style={{minWidth:"270px"}}>
                                <TextInput
                                    label='Standard Team Deposit (HK$)'
                                    value={newMoot.teamDepositAmount}
                                    onChange={e => setNewMoot({
                                        ...newMoot,
                                        teamDepositAmount: e.target.value
                                    })
                                    }/>
                                </div>
                            </Grid>
                        </Grid>    
                        <Grid container item spacing={4} xs={12}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Team Registration Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.teamRegistrationOpenDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            teamRegistrationOpenDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Team Registration Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.teamRegistrationCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => handleDateChangeWith59Seconds(e, 'teamRegistrationCloseDate')}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Team Member Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.teamMemberOpenDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            teamMemberOpenDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Team Member Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.teamMemberCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => handleDateChangeWith59Seconds(e, 'teamMemberCloseDate')}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Clarification Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.clarificationOpenDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            clarificationOpenDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Clarification Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.clarificationCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => handleDateChangeWith59Seconds(e, 'clarificationCloseDate')}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Claimant Memo Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.claimantDocumentUploadOpenDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            claimantDocumentUploadOpenDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Claimant Memo Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.claimantDocumentUploadEndDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => handleDateChangeWith59Seconds(e, 'claimantDocumentUploadEndDate')}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Respondent Memo Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.respondentDocumentUploadOpenDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            respondentDocumentUploadOpenDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Respondent Memo Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.respondentDocumentUploadEndDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => handleDateChangeWith59Seconds(e, 'respondentDocumentUploadEndDate')}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Show Team Oral Details (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.showOralDetailsTeamOpenDateValue)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            showOralDetailsTeamOpenDateValue: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Critique Available (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.critiqueAvailableDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '270px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            critiqueAvailableDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} style={{marginTop: '4rem'}}>                            
                            <Typography component='h2' variant='h5' style={{marginBottom: '1rem'}}>Arbitrator Settings</Typography>
                        </Grid>
                        <Grid container item spacing={4} xs={12} >
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Arbitrator Registration Open (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.arbitratorRegistrationOpenDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            arbitratorRegistrationOpenDate: utcFromHongKongTime(e)
                                        })
                                        }                                       
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Arbitrator Registration Close (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.arbitratorRegistrationCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            arbitratorRegistrationCloseDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            {/*NEW below here*/}
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Ranking Claimant Memo (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.rankingClaimantMemoCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            rankingClaimantMemoCloseDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Ranking Respondent Memo (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.rankingRespondentMemoCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            rankingRespondentMemoCloseDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Final Ranking Claimant Memo (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.finalRankingClaimantMemoCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            finalRankingClaimantMemoCloseDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDateTimePicker
                                        label="Final Ranking Respondent Memo (HKT)"
                                        inputFormat="MM/dd/yyyy hh:mm aa"
                                        value={hongKongTimeFromUTC(newMoot.finalRankingRespondentMemoCloseDate)}
                                        renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                        onChange={e => setNewMoot({
                                            ...newMoot,
                                            finalRankingRespondentMemoCloseDate: utcFromHongKongTime(e)
                                        })
                                        }
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid container item spacing={4} xs={12} style={{marginTop:"-1rem"}}>
                                <Grid item xs={12} sm="auto">
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDateTimePicker
                                            label="Show Arbitrator Oral Details (HKT)"
                                            inputFormat="MM/dd/yyyy hh:mm aa"
                                            value={hongKongTimeFromUTC(newMoot.showOralDetailsArbitratorsOpenDateValue)}
                                            renderInput={(params) => <MUITextField style={{minWidth: '310px'}} {...params} />}
                                            onChange={e => setNewMoot({
                                                ...newMoot,
                                                showOralDetailsArbitratorsOpenDateValue: utcFromHongKongTime(e)
                                            })
                                            }
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} style={{marginTop: '4rem'}}>
                            <Typography component='h2' variant='h5' style={{marginBottom: '1rem'}}>
                                Clarification Categories
                            </Typography>
                        </Grid>
                        
                        <Grid container item spacing={2} xs={12}>
                            <Grid item xs={12}>
                                <Typography variant='body2'>
                                    Manage the categories available for clarification requests.
                                </Typography>
                            </Grid>
                            
                           
                            
                            {/* Existing categories */}
                            <Grid item xs={12}>
                                {mapWithIndex((category, index) => (
                                    <ClarificationCategoryItem
                                        key={index}
                                        category={category}
                                        onEdit={editClarificationCategory}
                                        onRemove={removeClarificationCategory}
                                    />
                                ), clarificationCategories)}
                                {clarificationCategories.length === 0 && (
                                    <Typography variant='body2' color='textSecondary'>
                                        No categories added yet.
                                    </Typography>
                                )}
                            </Grid>

                             {/* Add new category */}
                            <Grid container item spacing={2} xs={12}>
                                <Grid item xs={12} sm={6}>
                                    <TextInput
                                        label='New Category'
                                        value={newCategoryName}
                                        onChange={e => setNewCategoryName(e.target.value)}
                                        onKeyPress={e => e.key === 'Enter' && addClarificationCategory()}
                                        notRequired
                                    />
                                </Grid>
                                <Grid item xs={12} sm="auto" style={{display: 'flex', alignItems: 'center'}}>
                                    <Button 
                                        variant='outlined' 
                                        onClick={addClarificationCategory}
                                        disabled={!newCategoryName.trim()}
                                    >
                                        + Add Category
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} style={{marginTop: "3rem", display:"flex", gap:"10px"}}>
                            <Button disabled={saving} type="submit" variant='contained' color="primary">SAVE</Button>
                            {saving && <CircularProgress size={35}/>}
                            {saveMootError && <Typography color='error'>{saveMootError}</Typography>}
                            {validationError && <Typography color='error'>{validationError}</Typography>}
                        </Grid>
                    </Grid>
                    <Snackbar open={saved} onClose={handleClose} autoHideDuration={6000} >
                        <Alert onClose={handleClose}  severity="success" sx={{ width: '100%' }}>
                            Moot saved
                        </Alert>
                    </Snackbar>


                </form>
                </>
            }


        </Container>

    )
}


Moot.propTypes = {
    selectedMoot: PropTypes.object,
    getSelectedMoot: PropTypes.func
}

export default connect(
    (state, ownProps) => ({
        selectedMoot: state.moot.selectedMoot,
        selectedMootId: ownProps.match.params.mootId,
        saveMootError: state.moot.saveMootError
    }), {
        getSelectedMoot: getSelectedMoot,
        saveMoot : saveMoot
    })(Moot)
